module.exports = __webpack_public_path__ + "static/media/icons_Les Essentiels - bilan abdominal post partum.3860133d.svg";